package com.example.mystybag.appCore.model.pages

import com.example.mystybag.core.model.CountryItem

data class CompanyResponsiblePersonEditUIState(
    val personId: Long = 0L,
    val firstName: String = "",
    val firstNameErrorMsg: String = "",
    val firstNameIsError: Boolean = false,
    val lastName: String = "",
    val lastNameErrorMsg: String = "",
    val lastNameIsError: Boolean = false,
    val phoneNumber: String = "",
    val phoneNumberErrorMsg: String = "",
    val phoneNumberIsError: Boolean = false,
    val dialCode: String = "",
    val dialCodeErrorMsg: String = "",
    val dialCodeIsError: Boolean = false,
    val countries: List<CountryItem> = emptyList(),
    val showDialCodePicker: Boolean = false,
    val isLoading: Boolean = false,
    val isInitialLoad: Boolean = true
)
